module.exports = __webpack_public_path__ + "img/40_38_030_610.764fc361.jpg";